<div [loadingOverlay]="isLoading">
  <div class="card">
    <div class="card-header">
      <span>{{ taskTypeName }} Task Details</span>
      <button (click)="cancel()" class="btn-close" title="Close"></button>
    </div>
    <div class="card-body">
      @if (task) {
      <div class="row form-group">
        <div class="col-md-6">
          <ul class="list-group">
            <li class="list-group-item">
              <strong>Task Type</strong>
              <span class="float-end">{{taskTypeName}}</span>
            </li>
          </ul>
        </div>
        <div class="col-md-6">
          <ul class="list-group">
            <li class="list-group-item">
              <strong>Task Description</strong>
              <p [innerHTML]="taskTypeTips"></p>
            </li>
          </ul>
        </div>
      </div>
      <div class="card">
        <div class="card-header">
          {{ taskTypeName }}
        </div>
        <div class="card-body">
          <div class="mb-3">
            <strong>Page Url</strong><br />
            <div>
              <a [attr.href]="url" target="_blank" name="url" rel="noreferrer">{{ url }}</a>
            </div>
          </div>
          @if (pageType) {
          <div class="mb-3">
            <strong>Page Type</strong>
            <div>{{ pageType }}</div>
          </div>
          }
          <div class="mb-3">
            <strong>Notes for Content Writer</strong>
            <div>{{ notesForContentWriter }}</div>
          </div>
          <div class="mb-3">
            <strong>Notes for Implementation Specialist</strong>
            <div>{{ notesForImplementationSpecialist }}</div>
          </div>
        </div>
      </div>
      <div class="row" style="margin-bottom: 4px;">
        <div class="col-md-12">
          <app-components-specialist-taskfiles [options]="{taskId: task.TaskId, allowUpload: false, useSmallTitle: true}">
          </app-components-specialist-taskfiles>
        </div>
      </div>
      }
      <div class="card card-body bg-light d-block text-end mt-5">
        <button (click)="cancel()" class="btn btn-danger">
          <i class="fas fa-times"></i>
          Cancel
        </button>
      </div>
    </div>
  </div>
</div>